// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0afb77cb","455":"b4ea5dc4","977":"4fe1b6a8"}[chunkId] + ".chunk.js";
};